const UsersRouteModule = require('./UsersRoute')
const UsersRoute = UsersRouteModule.default || UsersRouteModule

module.exports = {
  UsersRoute
}